var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "txt",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.5,
    height: 18.051,
    viewBox: "0 0 13.5 18.051",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vrstva_x0020_1_25_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M102.123,0h6.035l5.115,5.331V15.7a2.348,2.348,0,0,1-2.345,2.35h-8.8a2.348,2.348,0,0,1-2.35-2.35V2.35A2.348,2.348,0,0,1,102.123,0Z",
    transform: "translate(-99.773 0)",
    fill: "#251d36",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(2.472 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M467.219,0V5.291h5.119Z",
    transform: "translate(-461.31)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.302
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M209.085,437.372v-2.567h-.938v-.713h2.711v.713h-.934v2.567Zm4.822,0h-.88l-.6-1.006-.6,1.006h-.884l1.042-1.75-.911-1.529h.88l.474.794.469-.794h.884l-.911,1.534Zm1.019,0v-2.567h-.934v-.713H216.7v.713h-.938v2.567Z",
    transform: "translate(-208.147 -424.192)",
    fill: "#fff"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.3d6b49d77ca6051a09f3f7a661209bbb.svg";
export { ForwardRef as ReactComponent };